import { render, staticRenderFns } from "./AccountPosting.vue?vue&type=template&id=04657021&"
import script from "./AccountPosting.vue?vue&type=script&lang=js&"
export * from "./AccountPosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports